import { FunctionComponent, ReactNode, useEffect, useRef } from 'react'
import styled, { css } from 'styled-components'

type StyledPlaylistItemWrapperProps = {
  isActive: boolean
}

const StyledPlaylistItemWrapper = styled.div<StyledPlaylistItemWrapperProps>`
  ${({
    theme: {
      colors: {
        blicktvGrey: { btvGrey_50, btvGrey_55, btvGrey_60 },
      },
    },
    isActive,
  }) =>
    css`
      position: relative;
      background-color: ${btvGrey_60};

      &:hover {
        background-color: ${btvGrey_55};
      }

      &:not(:last-child) {
        margin-bottom: 20px;
      }

      ${isActive &&
      css`
        margin: -4px;
        padding: 4px;
        background-color: ${btvGrey_50};

        &:hover {
          background-color: ${btvGrey_50};
        }

        &:not(:last-child) {
          margin-bottom: 16px;
        }
      `}
    `}
`

interface PlaylistItemWrapperProps {
  isActive?: boolean
  scrollToElement: (offset: number) => void
  children?: ReactNode
}

const PlaylistItemWrapper: FunctionComponent<PlaylistItemWrapperProps> = ({
  isActive,
  children,
  scrollToElement,
}) => {
  const itemRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (isActive && itemRef.current) {
      scrollToElement(itemRef.current.offsetTop)
    }
  }, [isActive, itemRef, scrollToElement])

  return (
    <StyledPlaylistItemWrapper ref={itemRef} isActive={!!isActive}>
      {children}
    </StyledPlaylistItemWrapper>
  )
}

export default PlaylistItemWrapper
